// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* ------------------------------------------------------------------------------------------ */
/* Based on the "Color Tokens" view -------------------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const colors: Styleguide["colors"] = {
    primary: {
        main: "#337761",
        contrast: "#ffffff",
        light: "#78BE21",
        lightest: "#EBF1EF",
        dark: "#214e3f",
    },
    secondary: {
        main: "#C4D600",
        contrast: "#333333",
        light: "#EAFF00",
        dark: "#909d00",
        // Store Custom Code
        alt: "#F28900",
    },
    tertiary: {
        main: "#033873",
        contrast: "#ffffff",
        light: "#016CD0",
        dark: "#001A3E",
    },
    common: {
        border: "#adadac",
        borderLight: "#d4d4d4",
        borderDark: "#adadac",
        accent: "#f5f5f5",
        accentContrast: "#333333",
        accentContrastLight: "#333333",
        background: "#ffffff",
        backgroundContrast: "#333333",
        disabled: "#F6F7F9",
        disabledDark: "#C1C8CF",
        // Store Custom Code
        borderDarker: "#202b33",
        gradient1: "linear-gradient(90deg, #337761 60%, #78BE21 110%)",
        gradient2: "linear-gradient(90deg, #033873 60%, #016CD0 110%)",
    },
    text: {
        main: "#333333",
        accent: "#333333",
        disabled: "#C1C8CF",
        link: "#3061C8",
        linkHover: "#033873",
        linkAlt: "#333333",
        linkAltHover: "#337761",
        input: "#333333",
        // Store Custom Code
        light: "#808080",
        lighter: "#bcbcbc",
        lightest: "#F6F7F9",
    },
    success: {
        main: "#337761",
        contrast: "#ffffff",
        light: "#C4D9D1",
        /* Store Custom Code - Start */
        lighter: "#EBF1EF",
        lightest: "#F4F9F7",
        /* Store Custom Code - End */
    },
    warning: {
        main: "#C45414",
        contrast: "#ffffff",
        light: "#ECC7B2",
        /* Store Custom Code - Start */
        lighter: "#F9EEE7",
        lightest: "#F9EEE7",
        /* Store Custom Code - End */
    },
    danger: {
        main: "#DF1642",
        contrast: "#ffffff",
        light: "#F0B9B9",
        /* Store Custom Code - Start */
        lighter: "#F9E7E7",
        lightest: "#FFF0F0",
        /* Store Custom Code - End */
    },
    info: {
        main: "#0070CD",
        contrast: "#ffffff",
        light: "#B6DEE8",
        /* Store Custom Code - Start */
        lighter: "#E7F1F9",
        lightest: "#E7F1F9",
        /* Store Custom Code - End */
    },
    neutral: {
        main: "#666666",
        contrast: "#ffffff",
        light: "#e0e0e0",
    },
    invert: {
        main: "#ffffff",
        contrast: "#0f0f0f",
        hover: "#0f0f0f",
        dark: "#ececec",
    },
    placeholder: {
        main: "#bcbcbc",
        disabled: "#e2e2e2",
    },
    button: {
        disabled: {
            main: "#d4d4d4",
            contrast: "#ffffff",
        },
    },
    header: {
        main: "#ffffff",
        contrast: "#333333",
        hover: "#337761",
        accent: "#333333",
        accentHover: "#337761",
        accentContrast: "#ffffff",
        // Store Custom Code
        breadcrumbs: "#979797",
    },
    menu: {
        mainNavigation: {
            main: "#ffffff",
            contrast: "#333333",
            hover: "#337761",
            underline: "#337761",
            accent: "#337761",
            accentContrast: "#ffffff",
            accentHover: "#337761",
            separator: "#d4d4d4",
            border: "#d4d4d4",
        },
        secondaryNavigation: {
            main: "#202b33",
            contrast: "#ffffff",
            hover: "#ffffff",
        },
        tertiaryNavigation: {
            main: "#f5f5f5",
            contrast: "#333333",
        },
        megaMenuWithTabs: {
            tabsBackground: "#f7f8fc",
            tabsBackgroundHover: "#ffffff",
        },
    },
    footer: {
        main: "#333f48",
        contrast: "#C1C8CF",
        alt: "#202b33",
        altContrast: "#bcbcbc",
    },
    swatch: {
        main: "#adadac",
        contrast: "#333333",
        hover: "#337761",
        selected: "#337761",
        selectedHover: "#214e3f",
    },
};

export default colors;
